//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    padding: 55px 15px;
    width: 68vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
`;